import { render, staticRenderFns } from "./export-client-layout.vue?vue&type=template&id=13a24532&scoped=true"
import script from "./export-client-layout.vue?vue&type=script&lang=js"
export * from "./export-client-layout.vue?vue&type=script&lang=js"
import style0 from "./export-client-layout.vue?vue&type=style&index=0&id=13a24532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a24532",
  null
  
)

export default component.exports